<template slot-scope="props">
  <div class="animated fadeIn">
    
    <form>
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
             <div slot="header" class="d-flex align-items-center justify-content-between" :class="isDark ? 'bg-dark border-secondary' : ''">
                <div>
                  <i class='fa fa-shopping-cart mr-2'></i><strong>Relatório de Gestão de Compras</strong>
                </div>
                <small class="text-muted">Configure os filtros para gerar o documento</small>
            </div>


            <!-- Seção 1: Tipo de Relatório -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-list-alt mr-2"></i>Tipo de Relatório</h6>
              <b-row>
                <b-col sm="12">
                  <b-form-group label-for="tipoRelatorio" description="Selecione o formato dos dados para o relatório." :class="isDark ? 'text-light' : ''">
                    <b-form-select 
                      id="tipoRelatorio"
                      v-model="tipoRelatorio"
                      :options="opcoesRelatorio"
                      :plain="true"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                      class="form-control-lg"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 2: Entidades e Pessoas -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-users mr-2"></i>Fornecedor e Produtos</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Fornecedor">
                    <cliente-pesquisa 
                      @retornaId="FORNECEDOR_ID = $event"
                      :idInicial="FORNECEDOR_ID"
                      label=""
                      place="Todos os fornecedores (opcional)"
                      labelBotao=""
                      ref="fornecedorPesquisa"
                      idModal="fornecedorModal">
                    </cliente-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Produto">
                    <produto-pesquisa
                      @retornaId="PRODUTO_ID = $event"
                      :idInicial="PRODUTO_ID"
                      label=""
                      place="Todos os produtos (opcional)"
                      labelBotao=""
                      ref="produtoPesquisa">
                    </produto-pesquisa>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 3: Período e Intervalo -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Período e Intervalo</h6>
              <b-row>
                <b-col md="4" sm="12">
                  <b-form-group label="Tipo de Data">
                      <b-form-select :plain="true" v-model="tipoData.valor" :options="tipoData.opcoes" />
                  </b-form-group>
                </b-col>
                
                <b-col md="4" sm="6">
                  <b-form-group label="Data Início">
                    <cec-input-data id="dt1" v-model="DT1" :state="DT1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="6">
                  <b-form-group label="Data Fim">
                    <cec-input-data id="dt2" v-model="DT2" :state="DT2 ? null : false" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 4: Filtros de Notas Fiscais e Status -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-file-text mr-2"></i>Filtros de Nota Fiscal</h6>
              <b-row>
                <b-col md="3" sm="6">
                  <b-form-group label="Nota Fiscal">
                      <b-form-select 
                          :plain="true"  
                          v-model="notaFiscal.valor" 
                          :options="notaFiscal.opcoes">
                      </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="6">
                  <b-form-group label="Estoque">
                      <b-form-select :plain="true" v-model="estoque.valor" :options="estoque.opcoes" />
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="6">
                  <b-form-group label="Situação">
                      <b-form-select :plain="true" v-model="situacao.valor" :options="situacao.opcoes" />
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="6">
                  <b-form-group label="XML">
                      <b-form-select :plain="true" v-model="xml.valor" :options="xml.opcoes" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 5: Recepção e Ordenação -->
            <div class="section-container mb-2" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cog mr-2"></i>Recepção e Ordenação</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Recepção">
                      <b-form-select 
                          :plain="true"  
                          v-model="recepcao.valor" 
                          :options="recepcao.opcoes">
                      </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Ordenação">
                      <b-form-select :plain="true" v-model="ordem.valor" :options="ordem.opcoes" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div slot="footer" class="p-3" :class="isDark ? 'bg-dark border-top border-secondary' : 'bg-light'">
              <b-row class="justify-content-center">
                <b-col md="4" sm="12">
                  <b-button block size="lg" type="button" variant="primary" @click.stop.prevent="imprimir()" class="btn-generate shadow-sm">
                    <i class="fa fa-file-pdf-o mr-2"></i> GERAR RELATÓRIO
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
          
        </b-col>
      </b-row>
    </form>
    
  </div>
</template>

<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import moment from 'moment'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import ProdutoPesquisa from '../pesquisa/ProdutoPesquisa.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    ProdutoPesquisa,
    CecInputData
  },
  data () {
    return {
      FORNECEDOR_ID: null,
      PRODUTO_ID: null,
      DT1: moment().format('YYYY-MM-DD'),
      DT2: moment().format('YYYY-MM-DD'),
      
      tipoRelatorio: '1',
      
      tipoData: {
        opcoes: [
          { value: 'C', text: 'Da Data da Compra' },
          { value: 'D', text: 'Do Desembarque' }
        ],
        valor: 'C'
      },
      
      notaFiscal: {
        opcoes: [
          { value: '', text: 'TODOS' },
          { value: '0', text: 'NÃO VINCULADA' },
          { value: '1', text: 'DIVERGENTE' },
          { value: '2', text: 'VINCULADA' },
          { value: '3', text: 'CONFIRMADA NA SEFAZ' }
        ],
        valor: ''
      },
      
      estoque: {
        opcoes: [
          { value: '', text: 'TODOS' },
          { value: 'S', text: 'SIM' },
          { value: 'N', text: 'NÃO' }
        ],
        valor: ''
      },
      
      situacao: {
        opcoes: [
          { value: '', text: 'TODOS' },
          { value: '0', text: 'CANCELADO' },
          { value: '1', text: 'EM CADASTRO' },
          { value: '2', text: 'FECHADO' }
        ],
        valor: ''
      },
      
      xml: {
        opcoes: [
          { value: '', text: 'TODOS' },
          { value: '1', text: 'SIM' },
          { value: '0', text: 'NÃO' }
        ],
        valor: ''
      },
      
      recepcao: {
        opcoes: [
          { value: '', text: 'TODOS' },
          { value: '0', text: 'NÃO SOLICITADO' },
          { value: '1', text: 'CONFERÊNCIA ABERTA' },
          { value: '2', text: 'EM CONFERÊNCIA' },
          { value: '5', text: 'CONFERIDO' }
        ],
        valor: ''
      },
      
      ordem: {
        opcoes: [
          { value: 'FD', text: 'Fornecedor e Data Compra' },
          { value: 'FE', text: 'Fornecedor Data Entrega' },
          { value: 'CF', text: 'Data da Compra e Fornecedor' },
          { value: 'DF', text: 'Data do Desembarque e Forn.' },
          { value: 'CFOP', text: 'CFOP' },
          { value: 'PRO', text: 'Produto' }
        ],
        valor: 'FD'
      }
    }
  },
  
  methods: {
    imprimir () {
      this.$store.commit('controle/setAguardando', true)
      this.isLoading = true

      const params = {
        dt1: this.DT1,
        dt2: this.DT2,
        fornecedorId: this.FORNECEDOR_ID || '',
        lbFornecedor: this.$refs.fornecedorPesquisa?.$refs?.auto?.display || '',
        produtoId: this.PRODUTO_ID || '',
        lbProduto: this.$refs.produtoPesquisa?.$refs?.auto?.display || '',
        tipoData: this.tipoData.valor,
        notaFiscal: this.notaFiscal.valor,
        estoque: this.estoque.valor,
        situacao: this.situacao.valor,
        xml: this.xml.valor,
        recepcao: this.recepcao.valor,
        ordem: this.ordem.valor,
        lbEmpresa: window.localStorage.getItem('nomeempresa') || '',
        lbUsuario: window.localStorage.getItem('nomeusuario') || '',
        tipoRel: this.tipoRelatorio
      }

      const uri = '/api/protected/relatorios/gestaocompras/analitico?' + new URLSearchParams(params).toString()
        
      this.$http.get(uri, {responseType: 'arraybuffer'})
      .then(response => {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast('Relatório Gerado com Sucesso!', {
          title: 'Sucesso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'relGestaoCompras.pdf') 
        link.download = 'RelGestaoCompras.pdf'
        
        const janela = window.open(link)
        janela.onload = function(){
          setTimeout(() => {
            janela.document.title = 'Relatório de Gestão de Compras'
          }, 2000);
        }
        this.$store.commit('controle/setAguardando', false)
      })
      .catch(erro => {
        this.$toast.error({
          title: 'Erro',
          message: 'Ocorreram erros ao gerar o Relatório',
          progressBar: false,
          showMethod: 'shake',
          position: 'top full width'
        })
        this.$store.commit('controle/setAguardando', false)
      })
    }
  },
  
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    
    opcoesRelatorio () {
      let opcoes = [
        { value: '1', text: 'Sintético' },
        { value: '2', text: 'Analítico' },
        { value: '3', text: 'Analítico com Detalhes' }
      ]
      return opcoes
    },

    isValid () {
      return !!this.DT1 && !!this.DT2
    }
  },
  
  created () {
    // Inicialização se necessário
  }
}
</script>

<style scoped>

.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #ebedef;
  transition: all 0.3s ease;
}

.section-container.dark-mode {
  background: #23282c;
  border-color: #3a4149;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  background: #ffffff;
}

.section-container.dark-mode:hover {
  background: #2f353a;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #63c2de;
}

.select-premium {
  border: 1px solid #20a8d8;
  color: #20a8d8;
  font-weight: 600;
  cursor: pointer;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  transition: transform 0.2s ease;
}

.btn-generate:hover {
  transform: translateY(-2px);
}

hr {
  border-top: 1px solid #ebedef;
}

hr.border-secondary {
  border-color: #3a4149 !important;
}

.form-group label {
  font-weight: 600;
  color: #4f5d73;
  margin-bottom: 0.5rem;
}

.dark-mode .form-group label {
  color: #c8ced3;
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelGestaoCompras.vue